export const production_URL = "beta.lionraincoat.com.vn/"